import Typography from '@mui/material/Typography';
import type React from 'react';
import ConfirmDialog from './ConfirmDialog';

interface ConfirmDownloadDialogProps {
  isOpen: boolean;
  downloadCount: number;
  available?: number;
  total?: number;
  formatLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDownloadDialog: React.FC<ConfirmDownloadDialogProps> = ({
  isOpen,
  downloadCount,
  available,
  total,
  formatLabel,
  onConfirm,
  onCancel,
}) => {
  const count = typeof available === 'number' ? available : downloadCount;
  const baseLabel = formatLabel ? String(formatLabel) : null;
  const noun = baseLabel
    ? count !== 1
      ? `${baseLabel.toLowerCase()}s`
      : baseLabel.toLowerCase()
    : count !== 1
      ? 'assets'
      : 'asset';
  const title = baseLabel ? `Confirm Download of ${baseLabel}` : `Confirm download ${noun}`;
  const confirmDisabled = typeof available === 'number' ? available <= 0 : count <= 0;

  return (
    <ConfirmDialog
      isOpen={isOpen}
      title={title}
      message={
        <Typography>
          Are you sure you&apos;d like to download {count} {noun}?
          {typeof available === 'number' && typeof total === 'number' && (
            <>
              <br />
              Proxy available for {available} of {total} items
              {total - available > 0 ? ` (will skip ${total - available})` : ''}.
            </>
          )}
        </Typography>
      }
      confirmDisabled={confirmDisabled}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default ConfirmDownloadDialog;
